const sides = [
  {
    id: 1,
    name: "Papadums",
    description: "Portion for 2",
    price: "£1.80"
  },
  {
    id: 2,
    name: "Vegetable Raita",
    description: "Curd (yogurt) mixed with light spices and assortment of green fruits and vegetables (mainly green pepper, cucumber, grapes)",
    price: "£2.40"
  },
  {
    id: 3,
    name: "Curd (Plain)",
    
    price: "£2.00"
  },
  {
    id: 4,
    name: "Extra Pau",
    
    price: "£1.00"
  },
  {
    id: 5,
    name: "Extra Sāmbhar",
    
    price: "£1.00"
  },
  {
    id: 6,
    name: "Coriander and Mint Chutney",
    
    price: "£1.00"
  },
  {
    id: 7,
    name: "Sweet-Tangy Chutney",
    description: "Dates-Jaggery-Tamarind",
    price: "£1.00"
  },
  {
    id: 8,
    name: "Besan Chutney",
    description: "Lemon-curry leaves-coriander-mustard seed",
    price: "£1.00"
  },
  {
    id: 9,
    name: "Tomato Chutney",
    description: "Mild-red-chillies, tomatoes, oil, garlic, soya sauce",
    price: "£1.00"
  }
];

export default sides;